// @flow

import React from 'react'
import StandardContactForm from '@/components/Forms/StandardContactForm'

type Props = {
  action: String,
}

export default ({ action }: Props) => (
  <StandardContactForm
    name="Arcadia At Home Brochure Request v2"
    action={action}
    submitLabel="Get The Brochures"
  />
)
